const jquery = window.jQuery

if (!jquery) {
  throw new Error('The Sprockets jQuery bundle must load before the Vite entrypoints')
}

export default jquery
